import { render, staticRenderFns } from "./ProjectEditAwsDocuments.vue?vue&type=template&id=92dad4b0"
import script from "./ProjectEditAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./ProjectEditAwsDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92dad4b0')) {
      api.createRecord('92dad4b0', component.options)
    } else {
      api.reload('92dad4b0', component.options)
    }
    module.hot.accept("./ProjectEditAwsDocuments.vue?vue&type=template&id=92dad4b0", function () {
      api.rerender('92dad4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectEditAwsDocuments.vue"
export default component.exports